import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function OrquestarProcesoPago_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "OrquestarProcesoPago",
    rutaEndPoint: "/GwOrquestarProcesoPagoPMPEBF",
    sistemaOrigen: "Web",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.BackendBilletera,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface OrquestarProcesoPago_Entrada {
  DatosTarjeta_Entrada: DatosTarjetaEntrada;
  DatosTransaccion_Entrada: DatosTransaccionEntrada;
}

export function builtOrquestarProcesoPago_Entrada(
  p_DatosTarjeta_Entrada: DatosTarjetaEntrada,
  p_DatosTransaccion_Entrada: DatosTransaccionEntrada
) {
  var retorno: OrquestarProcesoPago_Entrada = {
    DatosTarjeta_Entrada: p_DatosTarjeta_Entrada,
    DatosTransaccion_Entrada: p_DatosTransaccion_Entrada,
  };

  return retorno;
}

export interface DatosTarjetaEntrada {
  tipoTarjeta: string;
  numeroTarjeta: string;
  fechaExpTarjeta: string;
  cvvTarjeta: string;
  nombreTitularTarjeta: string;
  nombreEmpresaTransaccion: string;
}

export function builtDatosTarjetaEntrada(
  p_tipoTarjeta: string,
  p_numeroTarjeta: string,
  p_fechaExpTarjeta: string,
  p_cvvTarjeta: string,
  p_nombreTitularTarjeta: string,
  p_nombreEmpresaTransaccion: string
) {
  var retorno: DatosTarjetaEntrada = {
    tipoTarjeta: p_tipoTarjeta,
    numeroTarjeta: p_numeroTarjeta,
    fechaExpTarjeta: p_fechaExpTarjeta,
    cvvTarjeta: p_cvvTarjeta,
    nombreTitularTarjeta: p_nombreTitularTarjeta,
    nombreEmpresaTransaccion: p_nombreEmpresaTransaccion,
  };

  return retorno;
}

export interface DatosTransaccionEntrada {
  tipoOperacion: string;
  idTransaccion: string;
  numeroCuentaClienteSky: string;
  loginUsr: string;
  horaActual: string;
  fechaActual: string;
  propositoPago: string;
  importePago: string;
  importePagoMonedaLocal: string;
  tipoCambio: string;
  pais: string;
  codeStore: string;
  authidresponse: string;
  clerkId: string;
  origFecha: string;
  origHora: string;
  origStan: string;
  origMsg: string;
  sistemaOrigenPago: string;
  codigoMoneda: string;
  entidadBancaria: string;
  tipoPago: string;
  tokenVoltage: string;
  comentarios: string;
  MerchantId: string;
  CodigoSKY: string;
  Captura: string;
  Token: string;
  InstrumentIdentifier: string;
  IdSesion: string;
  EcommerceIndicator: string;
  AuthenticationTransactioId: string;
  Cavv: string;
  Eci: string;
  xid: string;
  transactionID: string;
  IdentificadorCliente: string;
  EciRaw: string;
  IndicadorDeCobroUcaf: string;
  DatosDeAutenticacionUcaf: string;
  IdentificadorTransaccionServidor: string;
  Version3DS: string;
  CredencialAlmacenadaEnArchivo: string;
  CredencialAlmacenadaEnUso: string;
  IdentificadorTransaccionRed: string;
  DatosEmisor: string;
  TransaccionAutenticacionId: string;
  DestinoPayPal: string;
  ProcesoPayPal: string;
}

export function builtDatosTransaccionEntrada(
  p_tipoOperacion: string,
  p_idTransaccion: string,
  p_numeroCuentaClienteSky: string,
  p_loginUsr: string,
  p_horaActual: string,
  p_fechaActual: string,
  p_propositoPago: string,
  p_importePago: string,
  p_importePagoMonedaLocal: string,
  p_tipoCambio: string,
  p_pais: string,
  p_codeStore: string,
  p_authidresponse: string,
  p_clerkId: string,
  p_origFecha: string,
  p_origHora: string,
  p_origStan: string,
  p_origMsg: string,
  p_sistemaOrigenPago: string,
  p_codigoMoneda: string,
  p_entidadBancaria: string,
  p_tipoPago: string,
  p_tokenVoltage: string,
  p_comentarios: string,
  p_MerchantId: string,
  p_CodigoSKY: string,
  p_Captura: string,
  p_Token: string,
  p_InstrumentIdentifier: string,
  p_IdSesion: string,
  p_EcommerceIndicator: string,
  p_AuthenticationTransactioId: string,
  p_Cavv: string,
  p_Eci: string,
  p_xid: string,
  p_transactionID: string,
  p_IdentificadorCliente: string,
  p_EciRaw: string,
  p_IndicadorDeCobroUcaf: string,
  p_DatosDeAutenticacionUcaf: string,
  p_IdentificadorTransaccionServidor: string,
  p_Version3DS: string,
  p_CredencialAlmacenadaEnArchivo: string,
  p_CredencialAlmacenadaEnUso: string,
  p_IdentificadorTransaccionRed: string,
  p_DatosEmisor: string,
  p_TransaccionAutenticacionId: string,
  p_p_DestinoPayPal: string,
  p_ProcesoPayPal: string
) {
  var retorno: DatosTransaccionEntrada = {
    tipoOperacion: p_tipoOperacion,
    idTransaccion: p_idTransaccion,
    numeroCuentaClienteSky: p_numeroCuentaClienteSky,
    loginUsr: p_loginUsr,
    horaActual: p_horaActual,
    fechaActual: p_fechaActual,
    propositoPago: p_propositoPago,
    importePago: p_importePago,
    importePagoMonedaLocal: p_importePagoMonedaLocal,
    tipoCambio: p_tipoCambio,
    pais: p_pais,
    codeStore: p_codeStore,
    authidresponse: p_authidresponse,
    clerkId: p_clerkId,
    origFecha: p_origFecha,
    origHora: p_origHora,
    origStan: p_origStan,
    origMsg: p_origMsg,
    sistemaOrigenPago: p_sistemaOrigenPago,
    codigoMoneda: p_codigoMoneda,
    entidadBancaria: p_entidadBancaria,
    tipoPago: p_tipoPago,
    tokenVoltage: p_tokenVoltage,
    comentarios: p_comentarios,
    MerchantId: p_MerchantId,
    CodigoSKY: p_CodigoSKY,
    Captura: p_Captura,
    Token: p_Token,
    InstrumentIdentifier: p_InstrumentIdentifier,
    IdSesion: p_IdSesion,
    EcommerceIndicator: p_EcommerceIndicator,
    AuthenticationTransactioId: p_AuthenticationTransactioId,
    Cavv: p_Cavv,
    Eci: p_Eci,
    xid: p_xid,
    transactionID: p_transactionID,
    IdentificadorCliente: p_IdentificadorCliente,
    EciRaw: p_EciRaw,
    IndicadorDeCobroUcaf: p_IndicadorDeCobroUcaf,
    DatosDeAutenticacionUcaf: p_DatosDeAutenticacionUcaf,
    IdentificadorTransaccionServidor: p_IdentificadorTransaccionServidor,
    Version3DS: p_Version3DS,
    CredencialAlmacenadaEnArchivo: p_CredencialAlmacenadaEnArchivo,
    CredencialAlmacenadaEnUso: p_CredencialAlmacenadaEnUso,
    IdentificadorTransaccionRed: p_IdentificadorTransaccionRed,
    DatosEmisor: p_DatosEmisor,
    TransaccionAutenticacionId: p_TransaccionAutenticacionId,
    DestinoPayPal: p_p_DestinoPayPal,
    ProcesoPayPal: p_ProcesoPayPal,
  };

  return retorno;
}

//SALIUDA
export interface OrquestarProcesoPago_Salida {
  RespuestaPagoTarjeta: RespuestaPagoTarjeta;
}

export interface RespuestaPagoTarjeta {
  respuestaMotorPago: string;
  mensajeRespuestaMotorPago: string;
  codigoRespuestaMotorPago: string;
  numeroAutorizacionPago: string;
  numeroReferenciaPago: string;
  respuestaBRM: string;
  nombreMotorPagos: string;
  origStan: string;
  origMsg: string;
}

export type OrquestarProcesoPago_Respuesta = EncabezadoRespuestaInterna &
  OrquestarProcesoPago_Salida;
